const ORDER_STATUS = {
  PENDING: 'pending',
  SHIPPING: 'shipping',
  DONE: 'done',
  OVER: 'over',
};

export const ALL_STATUS = 'all status';
export default ORDER_STATUS;
